import { render, staticRenderFns } from "./SourceDialog.vue?vue&type=template&id=66719e43"
import script from "./SourceDialog.vue?vue&type=script&lang=js"
export * from "./SourceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports